import { getApiUrl } from "Infrastructure/Api/Api";

export const downloadFile = async (path: string) => {
	window.open(`${getApiUrl()}${path}`, "_blank");
};
